import { render, staticRenderFns } from "./CardModalTasks.vue?vue&type=template&id=a39cd2d8&scoped=true"
import script from "./CardModalTasks.vue?vue&type=script&lang=js"
export * from "./CardModalTasks.vue?vue&type=script&lang=js"
import style0 from "./CardModalTasks.vue?vue&type=style&index=0&id=a39cd2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39cd2d8",
  null
  
)

export default component.exports